import { render, staticRenderFns } from "./s-page.vue?vue&type=template&id=82459b40"
import script from "./s-page.vue?vue&type=script&lang=js"
export * from "./s-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.6_supports-color@8.1.1____6d4bc6e641adf69df12baf0f484d3174/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports